(function(angular) {
    'use strict';

    var directiveName = 'apPatientSearch';

    angular.module('aprima-core-ui').directive(directiveName, [
        'ApReadonlyFindControl',
        'PatientRepository',
        'QuicksearchFactory',
        ApPatientSearch,
    ]);

    function ApPatientSearch(
        ApReadonlyFindControl,
        PatientRepository,
        QuicksearchFactory
    ) {
        var validationKey = 'patientMatch';
        var idProperty = 'Id';
        var templateUrl = '/core-ui/views/directives/find/apPatientSearch.html';
        
        var directiveDefinition = ApReadonlyFindControl.init(
            directiveName,
            PatientRepository.getPatient,
            QuicksearchFactory.updateList,
            validationKey,
            templateUrl,
            idProperty,
            validator,
            true,
            onInitCtrl
        );

        return directiveDefinition;
        
        function onInitCtrl(ctrl) {
            ctrl.placeholderText = 'Search patients';
            ctrl.getSearchTextFromPatient = getSearchTextFromPatient;
        }

        function validator(patient) {
            var isValid =  !patient ||
                           (patient[idProperty] &&
                           (patient.hasOwnProperty('Name') || (patient.hasOwnProperty('LastName') && patient.hasOwnProperty('FirstName'))));
            return isValid;
        }

        function getSearchTextFromPatient(patient) {
            if(patient && patient.Name){
                return patient.Name;
            }
            else if (patient && patient.LastName && patient.FirstName) {
                return patient.LastName + ', ' + patient.FirstName;
            }
            return '';
        }
    }

})(window.angular);
